import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function BreedCard({ breed, index = 0 }) {
    const { t } = useLang();
    return (
        <Link
            to={`/breeds/${breed.slug}`}
            data-testid={`breed-card-${breed.slug}`}
            className="group block relative overflow-hidden rounded-[12px] bg-white shadow-soft hover:shadow-lift transition-shadow duration-500 ease-editorial"
        >
            <div className="relative overflow-hidden aspect-[4/5]">
                <img
                    src={breed.image}
                    alt={breed.name}
                    loading="lazy"
                    style={{ objectPosition: breed.objectPosition || "center" }}
                    className="w-full h-full object-cover scale-100 group-hover:scale-105 transition-transform duration-[1400ms] ease-editorial"
                />
                <div className="absolute inset-0 hero-scrim opacity-70" />
                <div className="absolute top-6 left-6 text-white/80 overlabel">
                    <span className="mr-2 text-gold-light">0{index + 1}</span> {breed.classification.split(" ")[0]}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-8">
                    <h3 className="font-serif text-white text-3xl md:text-4xl leading-tight tracking-tight">
                        {breed.name}
                    </h3>
                    <p className="text-white/80 mt-2 text-sm max-w-xs">
                        {breed.tagline}
                    </p>
                </div>
            </div>
            <div className="p-6 flex items-center justify-between border-t border-border">
                <div className="flex items-baseline gap-4">
                    <div>
                        <div className="overlabel text-earth text-[10px]">{breed.quickFacts[0].label}</div>
                        <div className="font-serif text-lg kbd-num">{breed.quickFacts[0].value}</div>
                    </div>
                    <div className="w-px h-8 bg-border" />
                    <div>
                        <div className="overlabel text-earth text-[10px]">{breed.quickFacts[1].label}</div>
                        <div className="font-serif text-lg kbd-num">{breed.quickFacts[1].value}</div>
                    </div>
                </div>
                <span className="flex items-center gap-2 text-sm text-forest">
                    {t("common.buttons.readEssay")}
                    <ArrowUpRight size={16} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
            </div>
        </Link>
    );
}
